import { useContext } from 'react';

import { AudienceContext, AudienceContextProps } from './AudienceProvider';

export function useAudience(): AudienceContextProps {
  const audience = useContext(AudienceContext);

  return audience;
}
